
export const GameEventType = {
    READY: "Ready",
    SOUND_CHANGED: "SoundChanged",
    GAME_UI_OVERLAP: "GameUIOverlap",
	COIN_ENABLED: "CoinEnabled",
	COIN_DISABLED: "CoinDisabled",
}


export function createGameService(cb) {

    let callBack = cb

    
    

    function gameEventsProcessor(eventName, targetName, context) {

        // console.log("trackGameEventListeners  eventName: " + eventName + " targetName: " + targetName + " context " + JSON.stringify(context));
        switch (eventName) {



            case 'balance_update': {

                if (!isLobbyEnabled){
                    //don't need in Light Coin
                    callBack({ type: GameEventType.READY })
                }


            }



            case 'initial-settings': {
                if (!context) break;
                //      console.log("trackGameEventListeners  eventName: " + eventName + " targetName: " + targetName + " context " + JSON.stringify(context));

                // if (context.isLeftHandedUI != undefined) {

                //   isLeftHandedUI.set(context.isLeftHandedUI)
                // }



                if (context.soundsVol) {
                    //soundVolume.set(context.soundsVol);
                    callBack({ type: GameEventType.SOUND_CHANGED, value: context.soundsVol })

                    // console.log("SOUNDS_VOL_________  eventName: " + eventName + " targetName: " + targetName + " context " + JSON.stringify(context));
                }

                break;
            }
            case 'settings-change': {

                switch (targetName) {
                    case 'isLeftHandedUI':
                        isLeftHandedUI.set(!!context)
                        break;
                    case 'soundsVol':
                        //soundVolume.set(context)
                        callBack({ type: GameEventType.SOUND_CHANGED, value: context })


                        break;
                }
                break;
            }
            case 'game_ui_overlap': {
                callBack({ type: GameEventType.GAME_UI_OVERLAP, value: !!context })
                // if (State.isGameOverlappedByUI !== !!context) {
                //   State.isGameOverlappedByUI = !!context;

                // }
                break;
            }
			// case 'pre_play': {
            //     callBack({ type: GameEventType.COIN_DISABLED })
            //     break;
            // }
			// case 'finish_round_animations': {
            //     callBack({ type: GameEventType.COIN_ENABLED })
            //     break;
            // }
        }
    }

	function onPostMessage(event) {
        const context = event.data;

        switch (context.name) {
            //INIT_EXT_WIDGETS
            case 'init_ext_widgets':
                callBack({ type: GameEventType.READY })
                break;

			case 'enable_ext_widgets':
                callBack({ type: GameEventType.COIN_ENABLED })
                break;

            case 'disable_ext_widgets':
                callBack({ type: GameEventType.COIN_DISABLED })
                break;

            case 'game_ui_overlap':
				callBack({ type: GameEventType.GAME_UI_OVERLAP, value: !!context?.isOverlapped })
                break;

            default:
            // do nothing
        }
    }
    let isLobbyEnabled = false
    function activate(aLobbyEnabled) {
        isLobbyEnabled = aLobbyEnabled

        if (!window.trackGameEventListeners) {
            window.trackGameEventListeners = [];
        }
        window.trackGameEventListeners.push(gameEventsProcessor);
        window.addEventListener('message', onPostMessage);
    }


    function deactivate() {
        if (window.trackGameEventListeners) {

            window.trackGameEventListeners = window.trackGameEventListeners.filter(function (item) {
                return item !== gameEventsProcessor
            })

        }
		window.removeEventListener('message', onPostMessage);

    }
	

    return {
        activate,
        deactivate,
    }
}

